import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay, Navigation } from 'swiper/modules';

window.sliderPageHero = function(data) {
	return {
		swiper: null,

		init() {
			this.swiper = new Swiper(this.$root, {
				modules: [Autoplay, EffectFade, Pagination],
				slidesPerView: 1,
				speed: 1000,
				loop: true,
				effect: 'fade',
				autoplay: false,
				autoplay: {
					delay: 3000,
				},
				pagination: {
					el: this.$refs.pagination,
					clickable: true,
				},
			});
		}
	}
}


window.gallery = function(data) {
	return {
		init() {
			this.swiper = new Swiper(this.$refs.container, {
				modules: [Navigation],
				loop: true,
				slidesPerView: 1,
				spaceBetween: 0,
				navigation: {
					nextEl: this.$refs.navigation_next,
					prevEl: this.$refs.navigation_prev,
				},
			});
		},
	}
}
